import { Box, ColorOptions, IconOptions, ModBox, Spacer, SpacerNew, TextNew } from '@jfs/ui-new'
import { FC, memo, useState } from 'react'
import { TooltipView } from '../../../../../../src/comps/TootTipView'
import { TextInputWithDelete } from '../../../../../comps/TextInputWithDelete'
import { pages, tooltipConfig } from '../../../../../util/util'
import { FileModeTextInput, PassKeyTextInput } from '../InfoDropDown'
import { styles } from '../ReportingStyles'
import { passwordPlaceholder } from '../helper'

export const EmailAndSftpFileTransferModeComponent: FC = memo(
  ({ setFieldValue, fieldName, allValues, label, editable, sUpdate, isNewPassword, setIsNewPassword }: any) => {
    const [passwordEmailError, setEmailPasswordError] = useState('')
    const [passwordSftpError, setSftpPasswordError] = useState('')
    const [sNewEmailPassword, setNewEmailPassword] = useState(isNewPassword?.email)
    const [sNewSftpPassword, setNewSftpPassword] = useState(isNewPassword?.sftp)

    const updateEmailConfig = (value: any, key: any) => {
      const currentFiled = Object.assign({}, allValues[fieldName])
      currentFiled[key] = value

      //setFiledObject((prev: any) => ({ ...prev, [fieldName]: currentFiled }))
      validateTheFieldValue(value, key)
      setFieldValue(fieldName, currentFiled)
    }

    const regexPass = /^[a-zA-Z0-9]{8,40}$/
    const validateTheFieldValue = (value: any, key: any): boolean => {
      let isValid = false
      setNewEmailPassword(true)
      if (key === 'emailConfigPassKey') {
        if (value === passwordPlaceholder) {
          setIsNewPassword?.('email', false)
        } else {
          setIsNewPassword?.('email', true)
        }

        if (sUpdate && !sNewEmailPassword) {
          return true
        } else if (value?.length > 0 && value !== passwordPlaceholder) {
          if (!regexPass.test(value)) {
            setEmailPasswordError(
              'Invalid Email password, Password must contain 8 alpha-numeric characters. Special characters are not allowed.',
            )
            return false
          } else {
            setEmailPasswordError('')
            return false
          }
        }
      }

      if (key === 'sftpConfigPassKey') {
        setNewSftpPassword(true)
        if (value === passwordPlaceholder) {
          setIsNewPassword?.('sftp', false)
        } else {
          setIsNewPassword?.('sftp', true)
        }

        if (sUpdate && !sNewSftpPassword) {
          return true
        } else if (value?.length > 0 && value !== passwordPlaceholder) {
          if (!regexPass.test(value)) {
            setSftpPasswordError(
              'Invalid SFTP password, Password must contain 8 alpha-numeric characters. Special characters are not allowed.',
            )
            return false
          } else {
            setSftpPasswordError('')
            return false
          }
        }
      }
      return isValid
    }

    return (
      <Box {...styles.mainView}>
        <SpacerNew size={15} direction={'vertical'} />

        <>
          <Box {...styles.textAndIcon}>
            <Box {...styles.titleAligner}>
              <TextNew title={label} {...styles.titleText} />
            </Box>
            <Box>
              <TooltipView
                iconColor={'#202F4D8A' as ColorOptions}
                fontSize={12}
                value={tooltipConfig.emailConfigInfo}
                top={-35}
                alignLeft={true}
                iconSize={14}
              />
            </Box>
          </Box>
          <SpacerNew size={5} direction={'vertical'} />

          <Box {...styles.configurationContainer}>
            <SpacerNew size={15} direction={'vertical'} />

            <TextInputWithDelete
              fieldName={fieldName}
              label={pages.create_config.email_recipients}
              placeholder={pages.create_config.email_recipients}
              editable={editable}
              //setFieldValue={setFieldValue}
              setFieldValue={(val: any) => updateEmailConfig(val, 'emailRecipients')}
              value={allValues[fieldName]?.emailRecipients}
              title={pages.create_config.email_recipients}
              isEmail={true}
              touched={true}
              error="Please enter Email ID followed by comma , or space"
              testID="email_recipients"
              allValues={allValues}
              badgeWidth={250}
              gridHeight={60}
              color={'#528BFF' as ColorOptions}
              borderColor={'#B9CBF0' as ColorOptions}
              titleColor={'#202F4D8A' as ColorOptions}
              setValuesOnFieldNameObject={true}
              fieldNameObjectKey={'emailRecipients'}
              bgColor={'#EAF1FF' as ColorOptions}
              valuesBorderColor={'TRANSPARENT'}
              fontFamily={'jiotype-medium'}
              borderRadius={4}
              showToolTipInfo={true}
              toolTipInfoComponent={
                <TooltipView
                  iconColor={'#202F4D8A' as ColorOptions}
                  fontSize={12}
                  value={tooltipConfig.emailConfigRecipentsInfo}
                  top={-35}
                  alignLeft={true}
                  iconSize={14}
                />
              }
            />

            <SpacerNew size={15} direction={'vertical'} />
            <FileModeTextInput
              onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigSubjLine')}
              //value={fieldObject.emailSubject}
              value={allValues[fieldName]?.emailConfigSubjLine}
              fieldName={fieldName}
              allValues={allValues}
              editable={editable}
              title={pages.create_config.subject_line}
              placeHolder={pages.create_config.subject_line_placeholder}
              width={'100%'}
              secureTextEntry={false}
              tooltipInfo={tooltipConfig.emailConfigSubjInfo}
              maxLength={150}
              isOptional={true}
              insertDateTime={true}
              top={-50}
            />

            <SpacerNew size={15} direction={'vertical'} />
            <ModBox flexDirection={'row'}>
              <Box f={1} flexDirection="row" flex={1}>
                <FileModeTextInput
                  onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigFileName')}
                  //value={fieldObject.emailFile}
                  value={allValues[fieldName]?.emailConfigFileName}
                  fieldName={fieldName}
                  allValues={allValues}
                  editable={editable}
                  title={pages.create_config.filename}
                  placeHolder={pages.create_config.filename_placeholder}
                  secureTextEntry={false}
                  rightIcon={'LOCK' as IconOptions}
                  rightOnPress={() => console.log('icon pressed')}
                  tooltipInfo={tooltipConfig.emailConfigFileNameInfo}
                  maxLength={25}
                  isOptional={true}
                  top={-20}
                  insertDateTime={true}
                  autoComplete={'new-password'}
                />

                <Spacer size={20} direction={'horizontal'} />

                <PassKeyTextInput
                  onChangeText={(val: string) => updateEmailConfig(val, 'emailConfigPassKey')}
                  //value={fieldObject.emailFilePassKey}
                  value={allValues[fieldName]?.emailConfigPassKey}
                  fieldName={fieldName}
                  allValues={allValues}
                  editable={editable}
                  title={pages.create_config.passkey}
                  placeHolder={pages.create_config.passkey_placeholder}
                  secureTextEntry={true}
                  rightAction={'Reset'}
                  rightOnPress={() => updateEmailConfig('', 'emailConfigPassKey')}
                  error={passwordEmailError}
                  tooltipInfo={tooltipConfig.emailConfigPassKeyInfo}
                  maxLength={40}
                  top={-35}
                  sUpdate={sUpdate}
                  autoComplete={'new-password'}
                />
              </Box>
            </ModBox>

            <SpacerNew size={15} direction={'vertical'} />
          </Box>
        </>

        <>
          <Spacer size={40} direction={'vertical'} />
          <Box {...styles.textAndIcon}>
            <Box {...styles.titleAligner}>
              <TextNew title={pages.create_config.sftp_configuration} {...styles.titleText} />
            </Box>
            <Box>
              <TooltipView
                iconColor={'#202F4D8A' as ColorOptions}
                fontSize={12}
                value={tooltipConfig.sftpConfigInfo}
                top={-35}
                alignLeft={true}
                iconSize={14}
              />
            </Box>
          </Box>
          <SpacerNew size={5} direction={'vertical'} />
          <Box {...styles.configurationContainer}>
            <SpacerNew size={15} direction={'vertical'} />

            <TextInputWithDelete
              fieldName={fieldName}
              label={pages.create_config.notification_recipients}
              placeholder={pages.create_config.notification_recipients}
              editable={editable}
              //setFieldValue={setFieldValue}
              setFieldValue={(val: any) => updateEmailConfig(val, 'sftpNotifyRecipients')}
              value={allValues[fieldName]?.sftpNotifyRecipients}
              title={pages.create_config.notification_recipients}
              isEmail={true}
              touched={true}
              badgeWidth={250}
              gridHeight={60}
              error="Please enter Email ID followed by comma , or space"
              testID="sftp_recipients"
              allValues={allValues}
              color={'#528BFF' as ColorOptions}
              borderColor={'#B9CBF0' as ColorOptions}
              titleColor={'#202F4D8A' as ColorOptions}
              setValuesOnFieldNameObject={true}
              fieldNameObjectKey={'sftpNotifyRecipients'}
              fontFamily={'jiotype-medium'}
              borderRadius={4}
              showToolTipInfo={true}
              toolTipInfoComponent={
                <TooltipView
                  iconColor={'#202F4D8A' as ColorOptions}
                  fontSize={12}
                  value={tooltipConfig.sftpConfigRecipentsInfo}
                  top={-65}
                  alignLeft={true}
                  iconSize={14}
                />
              }
            />

            <SpacerNew size={15} direction={'vertical'} />
            <FileModeTextInput
              onChangeText={(val: string) => updateEmailConfig(val, 'sftpConfigSubjLine')}
              //value={fieldObject.emailSubject}
              value={allValues[fieldName]?.sftpConfigSubjLine}
              fieldName={fieldName}
              allValues={allValues}
              editable={editable}
              title={pages.create_config.subject_line}
              placeHolder={pages.create_config.subject_line_placeholder}
              width={'100%'}
              secureTextEntry={false}
              tooltipInfo={tooltipConfig.sftpConfigSubjInfo}
              maxLength={150}
              isOptional={true}
              insertDateTime={true}
              top={-50}
            />

            <SpacerNew size={15} direction={'vertical'} />
            <ModBox flexDirection={'row'}>
              <Box f={1} flexDirection="row" flex={1}>
                <FileModeTextInput
                  onChangeText={(val: string) => updateEmailConfig(val, 'sftpConfigFileName')}
                  //value={fieldObject.emailFile}
                  value={allValues[fieldName]?.sftpConfigFileName}
                  fieldName={fieldName}
                  allValues={allValues}
                  editable={editable}
                  title={pages.create_config.filename}
                  placeHolder={pages.create_config.filename_placeholder}
                  secureTextEntry={false}
                  rightIcon={'LOCK' as IconOptions}
                  rightOnPress={() => console.log('icon pressed')}
                  tooltipInfo={tooltipConfig.sftpConfigFileNameInfo}
                  maxLength={25}
                  isOptional={true}
                  top={-20}
                  insertDateTime={true}
                  autoComplete={'new-password'}
                />

                <Spacer size={20} direction={'horizontal'} />

                <PassKeyTextInput
                  onChangeText={(val: string) => updateEmailConfig(val, 'sftpConfigPassKey')}
                  //value={fieldObject.emailFilePassKey}
                  value={allValues[fieldName]?.sftpConfigPassKey}
                  fieldName={fieldName}
                  allValues={allValues}
                  editable={editable}
                  title={pages.create_config.passkey}
                  placeHolder={pages.create_config.passkey_placeholder}
                  secureTextEntry={true}
                  rightAction={'Reset'}
                  error={passwordSftpError}
                  rightOnPress={() => updateEmailConfig('', 'sftpConfigPassKey')}
                  tooltipInfo={tooltipConfig.sftpConfigPassKeyInfo}
                  maxLength={40}
                  top={-20}
                  sUpdate={sUpdate}
                  autoComplete={'new-password'}
                />
              </Box>
            </ModBox>

            <SpacerNew size={15} direction={'vertical'} />
          </Box>
        </>
      </Box>
    )
  },
)
